module.exports = __webpack_public_path__ + "static/media/about-aulao.3660af6e.jpg";